import React, {useContext, useState, useEffect} from "react";
import {BrowserView,isBrowser,isMobile, MobileView} from 'react-device-detect';
import { Rating } from 'react-simple-star-rating';
import { AppContext, UserContext } from "../../AppContextProvider";
import {ButtonLoader} from "../utils/Loaders/ButtonLoader";
import {useFetch} from "../api/FetchApiData";
import { MediaUrl } from "../utils/media/Media";
import { useNavigate } from "react-router-dom";
import km_flag from './icons/km_flag.svg';
import tr_flag from './icons/tr_flag.png';
import fr_flag from './icons/fr_flag.png';
import sa_flag from './icons/sa_flag.jpg';
import ecart_flag from '../icons/home.webp';
import { useTranslation } from "react-i18next";

if (isMobile)
    import('./vitrine_mob.css').then(() => {});
else
    import('./vitrine.css').then(() => {});

export default function Vitrine(props)
{
    const [loading,setLoading] = useState(false);
    const [UserState,setUserState] = useContext(UserContext);
    const navigator = useNavigate();
    const fetchData = useFetch();
    const {t} = useTranslation();
    const [AppState,setAppState] = useContext(AppContext);
    const [devise,setDevise] = useState(AppState.settings.devise==='euro'?'€':'KMF')
    let itemTitle = props.article.title;
    //console.log(props.article);

    if(itemTitle.length>45)
    {
        itemTitle = itemTitle.substring(0,45)+' ...'
    }

    const UpdatePanier = async (panier)=>
    {
        setLoading(true);
        let _panier = {id:panier.id, articles:[]};
        panier.articles.forEach((item) => {
            _panier.articles.push({id:item.id,quantite:item.quantite})
        });
        fetchData.PutData(_panier, 'panier/').then((result)=>{
            if(result.result)
            {setLoading(false);setUserState({...UserState,panier:result.panier});}
        })
        
    }

    const AddToPanier = ()=>
    {
        let _data = {}
        const found = UserState.panier.articles.find((element) => element.article.id === props.article.id);
        if(found!==undefined)
        {
            _data = {id:found.id, 
                quantity:typeof(found.quantity)==='string' ? parseInt(found.quantity)+1 : found.quantity+1,
            }            
        }
        else{
            _data = {article:{id:props.article.id},quantity:1};             
            //_UserState.panier.articles.push(_art);
        }

        if(UserState.auth)
        {
            fetchData.PostData(_data,'panier/item/').then((result)=>
                {
                    if(result.result)
                    {
                        setUserState({...UserState,panier:result.panier}); 
                }});
        }
        else
        {
            let _UserState = UserState;
            if(found!==undefined)
            {
                let index = _UserState.panier.articles.indexOf(found);
                found.quantity = typeof(found.quantity)==='string' ? parseInt(found.quantity)+1 : found.quantity+1;
                found.article = {title:props.article.title,id:props.article.id,image:props.article.image};
                _UserState.panier.articles[index] = found;

            }
            else
            {
                let _art = {article:{title:props.article.title,id:props.article.id,image:props.article.image},quantity:1};             
                _UserState.panier.articles.push(_art);
            }   
            setUserState({...UserState,panier:{..._UserState.panier}});
        }
    }
    

    useEffect(()=>{
        setDevise(AppState.settings.devise==='euro'?'€':'KMF');
    },[AppState.settings.devise])

    const PriceSticker = ()=>
    {
        if(props.article.promo===null)
            return(
                <div className="SpanPrice" style={{fontWeight:'bold'}}>
                    <span>{props.article.price} <i>{' '+devise}</i></span>
                    {(!!props.article.is_location && props.article.is_location) && <span style={{color:'blue'}}><i>location</i></span>}
                </div>
            )
        else
        {
            let new_price = props.article.price - ((props.article.price*props.article.promo.reduction)/100);
            return(
                <div className="SpanPrice" style={{}}>
                    <span style={{textDecoration:'line-through'}}>{props.article.price} {devise}</span>
                    <span style={{color:'red'}}><b>-{props.article.promo.reduction}% : {new_price} {devise}</b></span>
                </div>
            )
        }
    }

    const Ecarts = ()=>{
        if(!!props.article.relative_error.relatif_errors && props.article.relative_error.relatif_errors.length > 0)
            return(
                <div className="div-ecarts" style={{fontSize:'xx-small',display:'flex',flexDirection:'row',alignItems:'center',justifyContent:'center'}}>
                    <div>{/*t('vitrine.ecarts')*/}<img style={{width:'16px',height:'16px'}} src={ecart_flag} /></div>
                    <div>
                        {props.article.relative_error.relatif_errors.map((err)=>{
                            return <span style={{color:Number(err[1]) < -5 ? 'red' : Number(err[1]) < 5 ? 'orangered' : 'green'}}>{err[0]} : {err[1]}%</span>
                            })
                        }
                    </div>
                </div>
            );
        else
            return;
    }

    let flag_from = km_flag;
    if(props.article.delivery_from==='France')
        flag_from = fr_flag;
    else if(props.article.delivery_from==='Turquie')
        flag_from = tr_flag;
    else if(props.article.delivery_from==='Arabie Saoudite')
        flag_from = sa_flag;


    return(
        <div id="Vitrine">
            <BrowserView>
                    <div className="vitrine-div-image" onClick={e=>{navigator('/product/'+props.article.id)}}>
                        {PriceSticker()}
                        {Ecarts()}
                        <img style={{margin:'auto'}} src={MediaUrl(props.article.image)} /> 
                    </div>
                    <div id="infos">
                        <h5 style={{paddingRight:'10px',paddingLeft:'10px'}}>{itemTitle}</h5>
                        <div className="rating" style={{marginTop:'0px'}}>
                            <Rating size={20} readonly={true} initialValue={props.article.note} onClick={e=>{}} onPointerEnter={e=>{}} onPointerLeave={e=>{}} onPointerMove={e=>{}} />
                        </div>
                        <span style={{color:'green',fontSize:'x-small'}}>{props.article.stock} {t('vitrine.en-stock')} <img className="flag" src={flag_from} /></span>
                        <div style={{marginTop:'0px'}}>
                            {!!props.article.near_delivery && <span style={{color:'violet',fontSize:'x-small'}}>{t('vitrine.delai-livraison')} {props.article.near_delivery.exp}-{props.article.near_delivery.arr}</span>}
                            {props.article.near_delivery===null && <span style={{color:'violet',fontSize:'x-small',marginTop:'15px'}}>{t('vitrine.no-delivery')}</span>}
                        </div>
                    </div>
                    <div id="btnAchat"><ButtonLoader onSubmit={e=>{AddToPanier();}} style={{backGroundColor:'rgba(246, 223, 91, 1)',fontSize:'small'}} loading={loading} text={t('vitrine.acheter')} /></div>
            </BrowserView>
            <MobileView style={{display:'flex',flexDirection:'row',alignItems:'center',justifyContent:'center',justifyItems:'center'}}>
                {PriceSticker()}
                <div id="image" onClick={e=>{navigator('/product/'+props.article.id)}}>
                    <img src={MediaUrl(props.article.image)} /> 
                </div>
                <div id="infos">
                    <div className="title">
                        <label>{itemTitle}</label>
                    </div>
                    <div className="rating">
                        <Rating size={20} onClick={e=>{}} readonly={true} initialValue={2.5} onPointerEnter={e=>{}} onPointerLeave={e=>{}} onPointerMove={e=>{}} />
                    </div>
                    <div className="stock">
                        <span style={{color:'green',fontSize:'x-small'}}>{props.article.stock} {t('vitrine.en-stock')} <img className="flag" src={fr_flag} /></span>
                        <div style={{marginTop:'5px'}}>
                            {!!props.article.near_delivery && <span style={{color:'violet',fontSize:'x-small'}}>{t('vitrine.delai-livraison')} {props.article.near_delivery.exp}-{props.article.near_delivery.arr}</span>}
                            {props.article.near_delivery===null && <span style={{color:'violet',fontSize:'x-small',marginTop:'15px'}}>{t('vitrine.no-delivery')}</span>}
                        </div>
                    </div>
                    {(!!props.article.relative_error.relatif_errors) && (props.article.relative_error.relatif_errors.length > 0) &&
                        <div className="stock" style={{}}>
                            <div style={{marginRight:'5px',display:'inline-block',verticalAlign:'middle'}}>{/*t('vitrine.ecarts')*/}<img style={{width:'25px',height:'25px'}} src={ecart_flag} /></div>
                            <div style={{display:'inline-block',verticalAlign:'middle'}}>
                                {props.article.relative_error.relatif_errors.map((err)=>{
                                    return <div>
                                            <span style={{fontSize:'xx-small',color:Number(err[1]) < -5 ? 'red' : Number(err[1]) < 5 ? 'orangered' : 'green'}}>{err[0]} : {err[1]}%</span>
                                        </div>
                                    })
                                }
                            </div>
                        </div>
                    }
                    <div id="btnAchat">
                        <ButtonLoader onSubmit={e=>{AddToPanier();}} style={{backGroundColor:'rgba(246, 223, 91, 0.8)',fontSize:'small'}} loading={loading} text={t('vitrine.acheter')} />
                    </div>
                </div>
            </MobileView>
        </div>
    );
}